"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
var lodash_1 = require("lodash");
function isEmptyState(state) {
    return lodash_1.isNil(state) || (immutable_1.isCollection(state) && state.isEmpty());
}
exports.isEmptyState = isEmptyState;
//# sourceMappingURL=utilities.js.map